import type { Client, ProductType, ProjectStyle } from "./types";

export type ProjectFilters = { productType: ProductType | null; style: ProjectStyle | null };
export const emptyProjectFilters: ProjectFilters = { productType: null, style: null };

export function projectMatchesFilters(client: Client, filters: ProjectFilters) {
  const productTypes = (client.productType || "").split(",").map((value) => value.trim());
  return (!filters.productType || productTypes.includes(filters.productType))
    && (!filters.style || client.style === filters.style);
}

export function filterProjects(clients: Client[], filters: ProjectFilters) {
  return clients.filter((client) => projectMatchesFilters(client, filters));
}

export function searchProjects(clients: Client[], query: string) {
  const term = query.trim().toLocaleLowerCase();
  return term ? clients.filter((client) => client.name.toLocaleLowerCase().includes(term)) : clients;
}

export const keyboardRows = [
  ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"],
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
  ["Z", "X", "C", "V", "B", "N", "M"]
] as const;

export type KeyboardKey = string | "Backspace" | "Clear" | "Space";
export function applyKeyboardKey(value: string, key: KeyboardKey) {
  if (key === "Backspace") return value.slice(0, -1);
  if (key === "Clear") return "";
  if (key === "Space") return value.endsWith(" ") ? value : value + " ";
  return value + key;
}

export type VideoExitState = "hidden" | "active" | "exiting";
export type VideoExitEvent = "show" | "touch" | "complete";
export function transitionVideoExit(state: VideoExitState, event: VideoExitEvent): VideoExitState {
  if (event === "show") return "active";
  if (event === "touch" && state === "active") return "exiting";
  if (event === "complete" && state === "exiting") return "hidden";
  return state;
}

export type GalleryTransitionState = "closed" | "opening" | "open" | "closing";
export type GalleryTransitionEvent = "open" | "opened" | "close" | "closed";
export function transitionGallery(state: GalleryTransitionState, event: GalleryTransitionEvent): GalleryTransitionState {
  if (event === "open" && state === "closed") return "opening";
  if (event === "opened" && state === "opening") return "open";
  if (event === "close" && state === "open") return "closing";
  if (event === "closed" && state === "closing") return "closed";
  return state;
}
